module.exports = __webpack_public_path__ + "static/media/henderson.26d035b2.jpg";